import React from 'react';
import { SearchInput, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@onward-delivery/design';

/**
 * The rate table's category dropdown and search box.
 * @param {{ categories: { key: string, label: string }[], category: string, onCategoryChange: Function, onSearchChange: Function }} props
 */
const RateFilters = ({ categories, category, onCategoryChange, onSearchChange }) => (
    <div className="flex flex-wrap items-center gap-3">
        <Select value={category} onValueChange={onCategoryChange}>
            <SelectTrigger className="w-64 max-w-full" aria-label="Rate category">
                <SelectValue />
            </SelectTrigger>
            <SelectContent>
                {categories.map(({ key, label }) => (
                    <SelectItem key={key} value={key}>
                        {label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
        <SearchInput
            className="w-64 max-w-full"
            placeholder="Search rates..."
            aria-label="Search rates"
            onValueChange={onSearchChange}
        />
    </div>
);

export default RateFilters;
